var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
var API_BASE_URL = process.env.ASSISTANT_API_BASE_URL;
if (!API_BASE_URL) {
    throw new Error("Missing environment variable: ASSISTANT_API_BASE_URL");
}
var RESOLVED_API_BASE_URL = API_BASE_URL;
function resolveApiUrl(path) {
    if (/^https?:\/\//i.test(path))
        return path;
    var normalizedPath = path.startsWith("/") ? path : "/".concat(path);
    return "".concat(RESOLVED_API_BASE_URL.replace(/\/$/, "")).concat(normalizedPath);
}
export function apiFetch(path, options) {
    var _a;
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, Promise, function () {
        var method, url, config, response_1, response_2, response_3, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    method = ((_a = options.method) !== null && _a !== void 0 ? _a : (options.body ? "POST" : "GET")).toUpperCase();
                    url = resolveApiUrl(path);
                    config = {
                        params: options.params,
                        headers: __assign(__assign({ Accept: "application/json" }, (options.body ? { "Content-Type": "application/json" } : {})), options.headers),
                        timeout: options.timeout,
                    };
                    if (!(method === "GET")) return [3 /*break*/, 2];
                    return [4 /*yield*/, axios.get(url, config)];
                case 1:
                    response_1 = _b.sent();
                    return [2 /*return*/, response_1.data];
                case 2:
                    if (!(method === "POST")) return [3 /*break*/, 4];
                    return [4 /*yield*/, axios.post(url, options.body, config)];
                case 3:
                    response_2 = _b.sent();
                    return [2 /*return*/, response_2.data];
                case 4:
                    if (!(method === "DELETE")) return [3 /*break*/, 6];
                    return [4 /*yield*/, axios.delete(url, config)];
                case 5:
                    response_3 = _b.sent();
                    return [2 /*return*/, response_3.data];
                case 6: return [4 /*yield*/, axios.request(__assign(__assign({}, config), { url: url, method: method, data: options.body }))];
                case 7:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
